import  * as actions from '../actions/actionTypes'
import { IStatsTeamVersusRecentState, IState } from '../store/state';

const statsTeamVersusRecent = ( state: IStatsTeamVersusRecentState = {}, action: any ) : IStatsTeamVersusRecentState => {
  switch (action.type) {
    case actions.FETCH_STATS_TEAM_VERSUS_RECENT_SUCCEEDED:
      return Object.assign( {}, state, action.data )
    case actions.FETCHING_STATS_ABORTED:
    case actions.FETCH_STATS_TEAM_VERSUS_RECENT_FAILED:
      console.error(action.type, action.data);
      return Object.assign( {}, state, action.data )
    default:
      return state
  }
}

export const getAllHeadToHeadScoresByChannel = ( state: IState, channelId: number ) => {
  if(state.statsTeamVersusRecent[channelId] && state.statsTeamVersusRecent[channelId].doc[0] && state.statsTeamVersusRecent[channelId].doc[0].data && state.statsTeamVersusRecent[channelId].doc[0].data.matches) {
    return state.statsTeamVersusRecent[channelId].doc[0].data.matches.map( ( match: any ) => match.result )
  }
  else {
    return [];
  }
}

export const getHighestScoreOfAllMatchesByChannel = ( state: IState, channelId: number ) => {
  const scores = getAllHeadToHeadScoresByChannel(state, channelId);

  if(scores.length) {
    return scores.reduce( ( before: number, score: any ) => {
      if( score.home > before ) {
        before = score.home
      } else if ( score.away > before ) {
        before = score.away
      }

      return before
    }, 0 )
  }

  return null
}

export default statsTeamVersusRecent
